import { getDocumentDigits } from '../../../../components/GetOrders/utils';
import { isCpfOrCnpjValid } from '../../../../utils/documento';

export type NormalizedDocumentField = {
  docDigits: string;
  isValidCpfCnpj: boolean;
  canSubmit: boolean;
};

export function normalizeDocumentField(document: string): NormalizedDocumentField {
  const docDigits = getDocumentDigits(document);
  const isValidCpfCnpj = isCpfOrCnpjValid(docDigits);

  return {
    docDigits,
    isValidCpfCnpj,
    canSubmit: isValidCpfCnpj,
  };
}
